import React, { useEffect } from "react";
import Styled from "./Scroll/Styles2";
import photos from "./Scroll/photos";
import "./Testimonial.css";
import button1 from "../../../../assets/images/Courses/Group 39223.png";
import button2 from "../../../../assets/images/Courses/Group 39222.png";
import StarRatings from "react-star-ratings";
import quote from "../../../../assets/images/Testimonial/ci_double-quotes-l.png";
import { useTranslation } from "react-i18next";
import OwlCarousel from "react-owl-carousel2";

function Testimonial() {
  const { t } = useTranslation();
  const contentWrapper = React.useRef(null);

  const options = {
    items: 4,
    nav: true,
    rewind: true,
    loop:true,
    autoplay: true,
    responsive: {
      0: {
        items: 1,
      },
      800: {
        items: 2,
      },
      1300: {
        items: 3,
      },
    },
  };
  return (
    <div className="testimonial">
      <div className="testimonial-text-head">
        <h2> {t("Testimonials")}</h2>
      </div>

      <div className="owl-div-2">
        <OwlCarousel options={options} navcontainer={".owl-nav"}>
          {photos.map((a) => (
            <div key={a.id} className="card" id="testimonial-card">
              <div className="card-body">
                <img src={quote} id="testimonial-logo" alt="testimonial"/>
                <br />
                <h5 className="card-title">{a.heading}</h5>
                <p className="card-text" style={{ minHeight: "150px" }}>
                  {a.msg}
                </p>
                <h5 className="card-title">{a.name}</h5>
                <h6 className="card-title">{a.designation}</h6>
                <StarRatings
                  starRatedColor="#F6B511"
                  rating={5}
                  starDimension="25px"
                  starSpacing="2px"
                />
              </div>
            </div>
          ))}
        </OwlCarousel>
      </div>
    </div>
  );
}

export default Testimonial;
